import api from '@/api'
import { normalize } from '@/utils/misc.js'

const state = () => ({
  isLoggedIn: false,
  rolesById: null, // e.g. { 1: { id: 1, name: "editor", ... }, ... }
  rolesByName: null, // e.g.{ editor: 1, admin: 0, contributor: 2, reviewer: 3}
  rolesByGemeinde: null // e.g. { 1: ['reviewer'], 2: ['contributor'] }
})

const mutations = {
  SET_ROLES_BY_Id(state, value) {
    state.rolesByName = value
  },
  SET_ROLES_BY_NAME(state, value) {
    state.rolesByName = value
  },
  SET_ROLES_BY_GEMEINDE(state, value) {
    state.rolesByGemeinde = value
  }
}

const actions = {
  async loadRoles({ commit }) {
    const data = await api.fetchRoles()
    commit('SET_ROLES_BY_ID', normalize(data, 'id'))
    commit('SET_ROLES_BY_NAME', normalize(data, 'name', (role) => role.id))
  },
  async loadRolesByGemeinde({ commit }) {
    const data = await api.fetchRolesByGemeinde()
    commit('SET_ROLES_BY_GEMEINDE', data)
  }
}

const getters = {
  isLoggedIn: (state) => false,
  getRolesForGemeinde: (state) => (id) => id in state.rolesByGemeinde ? state.rolesByGemeinde[id] : [],
  isEditorForGemeinde: (state, getters) => (id) => getters.getRolesForGemeinde(id).includes(state.roles['editor']),
  isContributorForGemeinde: (state) => (id) => getters.getRolesForGemeinde(id).includes(state.roles['contributor']),
  isReviewerForGemeinde: (state) => (id) => getters.getRolesForGemeinde(id).includes(state.roles['reviewer']),
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
